/**
 * Hive Flows — ``/workspace/flows`` layout.
 *
 * Pathless container that renders the <Outlet/> for its children:
 *   - ``flows.index.tsx``    → the hub (list + create + templates)
 *   - ``flows.$flowId.tsx``  → the visual editor
 *
 * Without this Outlet layout, navigating to the editor would render the hub
 * (the parent) with the child invisible — the editor would never open.
 */

import { Outlet, createFileRoute } from "@tanstack/react-router";

import { validateWorkspaceSearch } from "@/features/workspace-router";

export const Route = createFileRoute("/_authed/workspace/flows")({
  validateSearch: validateWorkspaceSearch,
  component: Outlet,
});
